import * as React from "react";
import { UitkText } from "uitk-react-text";
import { UitkRating } from "uitk-react-rating";
import { useLocalization } from "@shared-ui/localization-context";
import { useBexApi } from "@shared-ui/bex-api-context";
import { HotelRatingProps } from "components/flexComponents/Packages/typings";
import { ratingIcon } from "components/utility/RatingUtil";

export const HotelRating: React.FC<HotelRatingProps> = ({ rating, isText }) => {
  const { formatText } = useLocalization();
  const { context } = useBexApi();
  if (isText) {
    const isOneStar = Number(rating) === 1;
    const ratingText = formatText(
      `hotels.affinity.luxuryAmenities.starProperty.${isOneStar ? "one" : "other"}`,
      rating
    );

    return <UitkText size={200}>{ratingText}</UitkText>;
  } else {
    return <UitkRating overlay={false} className="uitk-type-100" rating={rating} icon={ratingIcon(context.locale)} />;
  }
};
